import { of as throwError, Observable, Subject } from "rxjs";

import { catchError, map } from "rxjs/operators";
import { Injectable, EventEmitter } from "@angular/core";
import { HttpClient, HttpHeaders, HttpParams } from "@angular/common/http";
import { environment } from "../../environments/environment";

import moment from "moment-timezone";
import { AuthenticationService } from "../auth/authentication.service";

@Injectable()
export class ProductService {
  refreshList$: EventEmitter<{}>;
  private ENDPOINT_LIST_PRODUCTS = "/products";
  private ENDPOINT_LIST_PRODUCT_FAMILY_LIST = "/product-families";
  private ENDPOINT_SALES_ORDER_PRODUCT = "/sales-order-products";
  private ENDPOINT_JOB_ORDER_PRODUCT = "/job-order-products";
  private ENDPOINT_LIST_PRODUCT_VIEWALL = "/products?viewAll=true";
  private ENDPOINT_LIST_PRODUCT_VIEWALL_V2 = "/v4-1/products?viewAll=false";
  private ENDPOINT_ASSETS_PICKLIST = "/v4/assets/pick-list";
  private ENDPOINT_ATTACHMENTS = "/attachments/";
  private productItemsSource = new Subject<any>();
  productitemsHandler = this.productItemsSource.asObservable();

  constructor(
    private http: HttpClient,
    private auth: AuthenticationService
  ) {
    this.refreshList$ = new EventEmitter();
  }
  setItems(items: any) {
    this.productItemsSource.next(items);
  }
  public getAllProductsByStatus() {
    return this.http
      .get(environment.base_url + this.ENDPOINT_LIST_PRODUCT_VIEWALL)
      .pipe(
        map((resp: any) => {
          // //console.log(resp);
          // return <Admin>resp;
          return resp;
        }),
        catchError((error) => {
          ////console.log(error);
          return throwError(error);
        })
      );
  }

  public getAllProductsV2(searchValue: any, parameters: any, filter: any = null, url : any = null, priceBookId: any = null,binId: any=null, activeStatusFlag?: any) {
    let params = new HttpParams();
    if (searchValue) {
      params = params.set("search", searchValue);
    }
    if (priceBookId) {
      params = params.set("priceBookId", priceBookId);
    }
    if( binId ) {
      params = params.set("binId", binId);
    }
    if( activeStatusFlag ) {
      params = params.set("isActive", activeStatusFlag);
    }
    if(filter){
      if(filter.productTypeIds && filter.productTypeIds.length >0){
        params = params.set("typeIds", filter.productTypeIds);
      }
      if(filter.productFamilyIds && filter.productFamilyIds.length >0){
        params = params.set("familyIds", filter.productFamilyIds);
      }
    }
     
    if (parameters)
      params = params
        .set("startFrom", parameters.startRow)
        .set("perPage", "25")
        .set("columnName", parameters.sortModel[0].colId)
        .set("sortOrder", parameters.sortModel[0].sort);

        var newUrl = url ? environment.base_url+url : environment.base_url + this.ENDPOINT_LIST_PRODUCT_VIEWALL_V2; 
    return this.http.get(newUrl, {
        observe: "response",
        params: params,
      })
      .pipe(
        map((resp: any) => {
          return resp;
        }),
        catchError((error) => {
          ////console.log(error);
          return throwError(error);
        })
      );
  }

  public getAllProducts() {
    return this.http
      .get(environment.base_url + this.ENDPOINT_LIST_PRODUCTS)
      .pipe(
        map((resp: any) => {
          // //console.log(resp);
          // return <Admin>resp;
          return resp;
        }),
        catchError((error) => {
          ////console.log(error);
          return throwError(error);
        })
      );
  }

  public getAllProductsPicklist() {
    return this.http.get(environment.base_url + "/v4/products/pick-list").pipe(
      map((resp: any) => {
        // //console.log(resp);
        // return <Admin>resp;
        return resp;
      }),
      catchError((error) => {
        ////console.log(error);
        return throwError(error);
      })
    );
  }
  public getAssetsPicklist() {
    return this.http
      .get(environment.base_url + this.ENDPOINT_ASSETS_PICKLIST, {
        observe: "response",
      })
      .pipe(
        map((resp: any) => {
          return resp;
        }),
        catchError((error) => {
          return throwError(error);
        })
      );
  }

  public getAllProductFamilies(active: any = null) {
    var active1 = ''
    if (active) { active1 = '?isActive=true' }
    return this.http
      .get(environment.base_url + this.ENDPOINT_LIST_PRODUCT_FAMILY_LIST + active1)
      .pipe(
        map((resp: any) => {
          // //console.log(resp);
          // return <Admin>resp;
          return resp;
        }),
        catchError((error) => {
          ////console.log(error);
          return throwError(error);
        })
      );
  }

  public deleteProductFamily(id: string) {
    return this.http
      .delete(
        environment.base_url +
          this.ENDPOINT_LIST_PRODUCT_FAMILY_LIST +
          "/by-id/" +
          id,
        { observe: "response" }
      )
      .pipe(
        map((resp: any) => {
          this.refreshList$.emit("Deleted Product Family");
          return resp;
        }),
        catchError((error) => {
          ////console.log(error);
          return throwError(error);
        })
      );
  }

  public createProduct(body: any) {
    return this.http
      .post(environment.base_url + this.ENDPOINT_LIST_PRODUCTS, body, {
        observe: "response",
      })
      .pipe(
        map((resp: any) => {
          this.refreshList$.emit(resp);
          return resp;
        }),
        catchError((error) => {
          ////console.log(error);
          return throwError(error);
        })
      );
  }

  public editProduct(body: any) {
    return this.http
      .put(environment.base_url + this.ENDPOINT_LIST_PRODUCTS, body, {
        observe: "response",
      })
      .pipe(
        map((resp: any) => {
          this.refreshList$.emit(resp);
          return resp;
        }),
        catchError((error) => {
          ////console.log(error);
          return throwError(error);
        })
      );
  }

  public deleteProduct(id: any) {
    return this.http
      .delete(environment.base_url + this.ENDPOINT_LIST_PRODUCTS + "/" + id, {
        observe: "response",
      })
      .pipe(
        map((resp: any) => {
          this.refreshList$.emit("Deleted Product");
          return resp;
        }),
        catchError((error) => {
          ////console.log(error);
          return throwError(error);
        })
      );
  }

  public createSalesOrderProduct(body: any) {
    return this.http
      .post(environment.base_url + this.ENDPOINT_SALES_ORDER_PRODUCT, body, {
        observe: "response",
      })
      .pipe(
        map((resp: any) => {
          this.refreshList$.emit(resp);
          return resp;
        }),
        catchError((error) => {
          ////console.log(error);
          return throwError(error);
        })
      );
  }

  public editSalesOrderProduct(body: any) {
    return this.http
      .put(environment.base_url + this.ENDPOINT_SALES_ORDER_PRODUCT, body, {
        observe: "response",
      })
      .pipe(
        map((resp: any) => {
          this.refreshList$.emit(resp);
          return resp;
        }),
        catchError((error) => {
          ////console.log(error);
          return throwError(error);
        })
      );
  }

  public deleteSalesOrderProduct(id: any) {
    return this.http
      .delete(
        environment.base_url + this.ENDPOINT_SALES_ORDER_PRODUCT + "/" + id,
        { observe: "response" }
      )
      .pipe(
        map((resp: any) => {
          this.refreshList$.emit("Deleted Product");
          return resp;
        }),
        catchError((error) => {
          ////console.log(error);
          return throwError(error);
        })
      );
  }

  public createJobOrderProduct(body: any) {
    return this.http
      .post(environment.base_url + this.ENDPOINT_JOB_ORDER_PRODUCT, body, {
        observe: "response",
      })
      .pipe(
        map((resp: any) => {
          this.refreshList$.emit(resp);
          return resp;
        }),
        catchError((error) => {
          ////console.log(error);
          return throwError(error);
        })
      );
  }

  public editJobOrderProduct(body: any) {
    return this.http
      .put(environment.base_url + this.ENDPOINT_JOB_ORDER_PRODUCT, body, {
        observe: "response",
      })
      .pipe(
        map((resp: any) => {
          this.refreshList$.emit(resp);
          return resp;
        }),
        catchError((error) => {
          ////console.log(error);
          return throwError(error);
        })
      );
  }

  public deleteJobOrderProduct(id: any) {
    return this.http
      .delete(
        environment.base_url + this.ENDPOINT_JOB_ORDER_PRODUCT + "/" + id,
        { observe: "response" }
      )
      .pipe(
        map((resp: any) => {
          this.refreshList$.emit("Deleted Product");
          return resp;
        }),
        catchError((error) => {
          ////console.log(error);
          return throwError(error);
        })
      );
  }

  public getAllProductType(active: any = null) {
    var active1 = ''
    if (active) { active1 = '?isActive=true' }
    return this.http.get(environment.base_url + "/product-types" + active1).pipe(
      map((resp: any) => {
        // //console.log(resp);
        // return <Admin>resp;
        return resp;
      }),
      catchError((error) => {
        ////console.log(error);
        return throwError(error);
      })
    );
  }

  public getAllProductUnitOfMeasurement(active: any = null) {
    var active1 = ''
    if (active) { active1 = '?isActive=true' }
    return this.http.get(environment.base_url + "/product-measure-units" + active1).pipe(
      map((resp: any) => {
        // //console.log(resp);
        // return <Admin>resp;
        return resp;
      }),
      catchError((error) => {
        ////console.log(error);
        return throwError(error);
      })
    );
  }
  public getProductById(id: any) {
    return this.http.get(environment.base_url + "/products/" + id).pipe(
      map((resp: any) => {
        // //console.log(resp);
        // return <Admin>resp;
        return resp;
      }),
      catchError((error) => {
        ////console.log(error);
        return throwError(error);
      })
    );
  }

  public getProductByIdJo(id: any) {
    return this.http
      .get(environment.base_url + "/job-order-products/" + id)
      .pipe(
        map((resp: any) => {
          // //console.log(resp);
          // return <Admin>resp;
          return resp;
        }),
        catchError((error) => {
          ////console.log(error);
          return throwError(error);
        })
      );
  }

  public getProductPickListSearchable(searchValue: any,priceBookId:any = null, url : any = null) {
    let params = new HttpParams();
      params = params.set("search", searchValue);
    
    if (priceBookId) {
      params = params.set("priceBookId", priceBookId);
    }
   var newUrl = url ? environment.base_url+url : environment.base_url + this.ENDPOINT_LIST_PRODUCT_VIEWALL_V2; 
    return this.http.get(newUrl, {params: params }) .pipe(
        map((resp: any) => {
          return resp;
        }),
        catchError((error) => {
          ////console.log(error);
          return throwError(error);
        })
      );

  }

  //**================================== History tab =========================*/
  public geProductHistory(
    startFrom: any,
    perPage: any,
    search: any,
    productId: any,
    columnName: any,
    sortOrder: any
  ) {
    let params = new HttpParams();
    if (startFrom) params = params.set("startFrom", startFrom);
    if (perPage) params = params.set("perPage", perPage);
    if (search) params = params.set("search", search);
    if (columnName) params = params.set("columnName", columnName);
    if (sortOrder) params = params.set("sortOrder", sortOrder);
    if (productId) params = params.set("productId", productId);
    return this.http
      .get(environment.base_url + "/bin-inventory-histories", {
        observe: "response",
        params: params,
      })
      .pipe(
        map((resp: any) => {
          return resp;
        }),
        catchError((error) => {
          return throwError(error);
        })
      );
  }

  //**================================== Get product picklist by search =========================*/
  public getProductPickListBySearchValue(searchValue: string) {
    this.http
      .get(
        environment.base_url +
          "/v4/products/pick-list/search?name=" +
          searchValue +
          "&limit=25"
      )
      .pipe(
        map((resp: any) => {
          return resp;
        }),
        catchError((error) => {
          return throwError(error);
        })
      );
  }

  //**================================== Get product picklist by search product sku =========================*/
  public getProductBySku(searchValue: string) {
    return this.http
      .get(
        environment.base_url +
          "/v4/products/pick-list/search?productSku=" +
          searchValue +
          "&limit=25"
      )
      .pipe(
        map((resp: any) => {
          return resp;
        }),
        catchError((error) => {
          return throwError(error);
        })
      );
  }

  //**================================== Upload File =========================*/
  public uploadProductPhoto(fileName: string, formData: any) {
    const headers = new HttpHeaders({
      "Authorization": "Bearer " + this.auth.getToken()
    });

    return this.http
      .post(
        environment.base_url +
          "/attachments/upload?parentId=" +
          moment().format("x") +
          "&parentType=PRODUCT_PROFILE",
        formData,
        { headers: headers, observe: "response" }
      )
      .pipe(
        map((resp: any) => {
          return resp;
        }),
        catchError((error) => {
          return throwError(error);
        })
      );
  }

  //**================================== Delete Attachment =========================*/
  public deleteAttachment(id: any) {
    return this.http
      .delete(environment.base_url + this.ENDPOINT_ATTACHMENTS + id, {
        observe: "response",
      })
      .pipe(
        map((resp: any) => {
          return resp;
        }),
        catchError((error) => {
          return throwError(error);
        })
      );
  }

  /******************************************* Product By checklist **************************/
   getAllProducttByChecklist(pmvId: any,checkListRecordId: any) {
    let params = new HttpParams();
    if (pmvId) { params = params.set("pmvId", pmvId);}
    if (checkListRecordId) { params = params.set("checkListRecordId", checkListRecordId);}
    return this.http.get(environment.base_url + "/v4/job-order-products",{ observe: "response", params: params }).pipe(map((resp: any) => {
        return resp;
      }),
      catchError((error) => {
        ////console.log(error);
        return throwError(error);
      })
    );
  }

  public createProductType(body: any) {
    return this.http
      .post(environment.base_url + "/product-types", body, {
        observe: "response",
      })
      .pipe(
        map((resp: any) => {
          return resp;
        }),
        catchError((error) => {
          //console.log(error);
          return throwError(error);
        })
      );
  }

  public updateProductType(body: any) {
    return this.http
      .put(environment.base_url + "/product-types", body, {
        observe: "response",
      })
      .pipe(
        map((resp: any) => {
          return resp;
        }),
        catchError((error) => {
          //console.log(error);
          return throwError(error);
        })
      );
  }

  public getProductTypeById(id: any) {
    return this.http.get(environment.base_url + "/product-types/" + id).pipe(
      map((resp: any) => {
        return resp;
      }),
      catchError((error) => {
        //console.log(error);
        return throwError(error);
      })
    );
  }
  public deleteProductType(id: any) {
    return this.http
      .delete(environment.base_url + "/product-types/" + id, {
        observe: "response",
      })
      .pipe(
        map((resp: any) => {
          this.refreshList$.emit("Deleted Product Types");
          return resp;
        }),
        catchError((error) => {
          //console.log(error);
          return throwError(error);
        })
      );
  }

  public createProductFamily(body: any) {
    return this.http
      .post(environment.base_url + this.ENDPOINT_LIST_PRODUCT_FAMILY_LIST, body, {
        observe: "response",
      })
      .pipe(
        map((resp: any) => {
          return resp;
        }),
        catchError((error) => {
          //console.log(error);
          return throwError(error);
        })
      );
  }

  public updateProductFamily(body: any) {
    return this.http
      .put(environment.base_url + this.ENDPOINT_LIST_PRODUCT_FAMILY_LIST, body, {
        observe: "response",
      })
      .pipe(
        map((resp: any) => {
          return resp;
        }),
        catchError((error) => {
          //console.log(error);
          return throwError(error);
        })
      );
  }

  public getProductFamilyById(id: any) {
    return this.http.get(environment.base_url + this.ENDPOINT_LIST_PRODUCT_FAMILY_LIST+"/" + id).pipe(
      map((resp: any) => {
        return resp;
      }),
      catchError((error) => {
        //console.log(error);
        return throwError(error);
      })
    );
  }

  public createProductUnit(body: any) {
    return this.http
      .post(environment.base_url + "/product-measure-units", body, {
        observe: "response",
      })
      .pipe(
        map((resp: any) => {
          return resp;
        }),
        catchError((error) => {
          //console.log(error);
          return throwError(error);
        })
      );
  }

  public updateProductUnit(body: any) {
    return this.http
      .put(environment.base_url + "/product-measure-units", body, {
        observe: "response",
      })
      .pipe(
        map((resp: any) => {
          return resp;
        }),
        catchError((error) => {
          //console.log(error);
          return throwError(error);
        })
      );
  }

  public getProductUnitById(id: any) {
    return this.http.get(environment.base_url + "/product-measure-units/" + id).pipe(
      map((resp: any) => {
        return resp;
      }),
      catchError((error) => {
        //console.log(error);
        return throwError(error);
      })
    );
  }
  public deleteProductUnit(id: any) {
    return this.http
      .delete(environment.base_url + "/product-measure-units/" + id, {
        observe: "response",
      })
      .pipe(
        map((resp: any) => {
          this.refreshList$.emit("Deleted Product Unit");
          return resp;
        }),
        catchError((error) => {
          //console.log(error);
          return throwError(error);
        })
      );
  }
 
  public createJobOrderProductInBulkFromAi(body: any) {
    return this.http
      .post(environment.base_url +'/job-order-products/ai-bulk', body, { observe: "response"}).pipe( map((resp: any) => {
          this.refreshList$.emit(resp);
          return resp;
        }),
        catchError((error) => {
          ////console.log(error);
          return throwError(error);
        })
      );
  }

  /******************************************* Product By Asset **************************/
   getAllProductsByAsset(searchValue: any, parameters: any, assetId:any) {
    let params = new HttpParams();
    if (searchValue) {
      params = params.set("search", searchValue);
    }
   
    if (parameters)
      params = params
        .set("startFrom", parameters.startRow)
        .set("perPage", "25")
        .set("columnName", parameters.sortModel[0].colId)
        .set("sortOrder", parameters.sortModel[0].sort);

   // if (assetId) { params = params.set("assetId", assetId);}
    return this.http.get(environment.base_url + "/products/consumed-by-asset/"+assetId,{ observe: "response", params: params }).pipe(map((resp: any) => {
        return resp;
      }),
      catchError((error) => {
        ////console.log(error);
        return throwError(error);
      })
    );
  }

  public createJobOrderProductForJO2(body: any) {
    return this.http
      .put(environment.base_url +'/v5/job-order-products', body, {
        observe: "response",
      })
      .pipe(
        map((resp: any) => {
          this.refreshList$.emit(resp);
          return resp;
        }),
        catchError((error) => {
          ////console.log(error);
          return throwError(error);
        })
      );
  }
   public updateJobOrderProductUnitPrice(body: { id: number; unitPrice: number }) {
    return this.http
      .patch(environment.base_url + "/v5/job-order-products/update-unit-price", body, {
        observe: "response",
      })
      .pipe(
        map((resp: any) => {
          this.refreshList$.emit(resp);
          return resp;
        }),
        catchError((error) => throwError(() => error)),
      );
  }
  
}
// Summary of changes:

// ✅ Removed deprecated imports:

// Removed import { Headers, Http, RequestOptions } from "@angular/http";
// Removed unused import { AnyAaaaRecord } from "dns";


// ✅ Updated constructor:

// Removed private httpOld: Http parameter


// ✅ Updated uploadProductPhoto method:

// Changed from using Headers and RequestOptions to HttpHeaders
// Changed from httpOld (old Http service) to http (HttpClient)
// Removed .json() call since HttpClient automatically parses JSON responses



// The code should now compile successfully with Angular 19!